module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-header"
  }, [_c('div', {
    class: {
      'h5-header-box': true, 'change-header': (_vm.changeHeader || _vm.$route.path === '/faq')
    }
  }, [_c('div', {
    staticClass: "h5-header-content"
  }, [_c('div', {
    staticClass: "logo-in-header"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home/header_logo.png",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-nav"
  }, [_c('div', {
    staticClass: "menu-phone pull-right"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "border-bottom"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t("index")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "border-bottom"
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t("download")))])], 1), _vm._v(" "), (_vm.hasToken) ? _c('li', {
    staticClass: "border-bottom nickname-li"
  }, [_c('router-link', {
    staticClass: "nickname",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.nickName) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "border-bottom",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('choose-lang-in-m')], 1), _vm._v(" "), (!_vm.hasToken) ? _c('li', {
    staticClass: "border-bottom"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("signIn")))])], 1) : _vm._e(), _vm._v(" "), (!_vm.hasToken) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("signUp")) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasToken) ? _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("signOut")) + "\n              ")])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fold-navigation",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-label": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home/h5_header_btn.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92f4f8a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/mainHeader/MainHeaderPhone.vue
// module id = 1369
// module chunks = 1